import { render, staticRenderFns } from "./CoreProgramCampaignSettingsPool.vue?vue&type=template&id=baa08dac&scoped=true&"
import script from "./CoreProgramCampaignSettingsPool.vue?vue&type=script&lang=js&"
export * from "./CoreProgramCampaignSettingsPool.vue?vue&type=script&lang=js&"
import style0 from "./CoreProgramCampaignSettingsPool.vue?vue&type=style&index=0&id=baa08dac&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa08dac",
  null
  
)

export default component.exports